<template>
  <el-dialog
    append-to-body
    width="600px"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="el-dialog-title" style="margin-bottom:10px">
        {{ info.name }}
      </div>
      <div v-for="(item, index) in table.data" :key="index" style="margin-bottom:5px">
        <span>{{ index + 1 }}、</span>
        <span style="margin-left:4px">{{ item.name }}</span>
      </div>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      info: {},
      btnLoading: false,
      visible: false,
      table: {
        data: [],
        total: 0,
        loading: false,
      },
    };
  },
  methods: {
    toggle(val) {
      this.visible = val;
    },
    getDetail(row) {
      this.info = row;
      this.init();
    },
    init() {
      let params = {
        id: this.info.id,
        page: 1,
        count: 9999,
      };
      this.$http
        .get("/admin/company/tagCompany", { params: params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    reset() {
      this.visible = false;
      this.info = {};
      this.table = {
        data: [],
        total: 0,
        loading: false,
      };
      this.$refs.elFormDomUploadDialog.resetFields();
    },
  },
};
</script>